(function () {
  const STORAGE_KEY = 'atvlugnuts_selected_machine';
  const CONTACT_URL = '/pages/contact';
  const FINDER_URL = '/#fitment-finder-section';

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function readMachine() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || !parsed.make || !parsed.year || !parsed.model) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeMachine(machine) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(machine));
      window.dispatchEvent(new CustomEvent('atvlugnuts:selected-machine-change', { detail: machine }));
    } catch (error) {
      return;
    }
  }

  function clearMachine() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      window.dispatchEvent(new CustomEvent('atvlugnuts:selected-machine-change', { detail: null }));
    } catch (error) {
      return;
    }
  }

  function machineName(machine) {
    return [machine.year, machine.make, machine.model, machine.trim].filter(Boolean).join(' ');
  }

  function shopUrl(machine) {
    if (machine.threadSize) {
      return '/search?type=product&q=' + encodeURIComponent(machine.threadSize);
    }
    return CONTACT_URL;
  }

  function refreshBar() {
    const bar = document.querySelector('[data-atv-selected-machine]');
    if (!bar) return;

    const machine = readMachine();
    if (!machine) {
      bar.hidden = true;
      return;
    }

    const name = machineName(machine);
    const nameEl = bar.querySelector('[data-atv-machine-name]');
    const threadEl = bar.querySelector('[data-atv-machine-thread]');
    const shopLink = bar.querySelector('[data-atv-shop-matching]');

    if (nameEl) nameEl.textContent = name;
    if (threadEl) {
      threadEl.textContent = machine.threadSize
        ? 'Likely Thread Size: ' + machine.threadSize
        : 'Thread Size: Verify before ordering';
      threadEl.classList.toggle('atv-selected-machine__thread--verify', !machine.threadSize);
    }
    if (shopLink) {
      shopLink.href = shopUrl(machine);
      shopLink.textContent = machine.threadSize ? 'Shop Matching Lug Nuts' : 'Get Fitment Help';
    }

    bar.hidden = false;
  }

  function getProductContext() {
    const node = document.querySelector('[data-atv-product-fitment-context]');
    if (!node) return null;
    return {
      threadSize: node.getAttribute('data-product-thread-size') || '',
      productText: normalize(node.getAttribute('data-product-text') || '')
    };
  }

  function productTextContainsMachine(context, machine) {
    if (!context || !context.productText) return false;
    const fullNeedle = normalize([machine.year, machine.make, machine.model].filter(Boolean).join(' '));
    return fullNeedle && context.productText.includes(fullNeedle);
  }

  function refreshProductMessage() {
    const message = document.querySelector('[data-atv-product-machine-message]');
    if (!message) return;

    const machine = readMachine();
    if (!machine) {
      message.hidden = true;
      return;
    }

    const context = getProductContext();
    const title = message.querySelector('[data-atv-product-machine-title]');
    const copy = message.querySelector('[data-atv-product-machine-copy]');
    const cta = message.querySelector('[data-atv-product-machine-cta]');
    const selectedThread = machine.threadSize || '';
    const productThread = context && context.threadSize ? context.threadSize : '';
    const exactMachineMatch = productTextContainsMachine(context, machine);

    message.classList.remove('atv-machine-fitment--match', 'atv-machine-fitment--warning');

    if (exactMachineMatch) {
      message.classList.add('atv-machine-fitment--match');
      title.textContent = 'Matches your selected machine';
      copy.textContent = 'This product appears to match ' + machineName(machine) + ' based on available fitment data. Verify your wheel setup before ordering.';
      cta.hidden = true;
    } else if (selectedThread && productThread && normalize(selectedThread) === normalize(productThread)) {
      message.classList.add('atv-machine-fitment--match');
      title.textContent = 'Thread size match';
      copy.textContent = 'Your selected machine appears to use ' + selectedThread + ', and this product is ' + productThread + '. Verify seat style and wheel setup before ordering.';
      cta.hidden = true;
    } else if (selectedThread && productThread && normalize(selectedThread) !== normalize(productThread)) {
      message.classList.add('atv-machine-fitment--warning');
      title.textContent = 'Possible mismatch';
      copy.textContent = 'Your selected machine may use ' + selectedThread + ', but this product is ' + productThread + '. Do not order unless you have verified your setup.';
      cta.hidden = false;
    } else {
      message.classList.add('atv-machine-fitment--warning');
      title.textContent = 'Verify fitment';
      copy.textContent = 'We do not have enough data to confirm this product for ' + machineName(machine) + '. Check thread size, seat style, and wheel setup before ordering.';
      cta.hidden = false;
    }

    message.hidden = false;
  }

  function refreshCollectionMessage() {
    const message = document.querySelector('[data-atv-collection-machine-message]');
    if (!message) return;

    const machine = readMachine();
    if (!machine) {
      message.hidden = true;
      return;
    }

    const name = message.querySelector('[data-atv-collection-machine-name]');
    const thread = message.querySelector('[data-atv-collection-machine-thread]');
    const cta = message.querySelector('[data-atv-collection-machine-cta]');

    if (name) name.textContent = machineName(machine);
    if (thread) {
      thread.textContent = machine.threadSize
        ? 'Recommended thread size: ' + machine.threadSize
        : 'We do not have confirmed thread size data yet. Use the products below as a guide or contact us before ordering.';
    }
    if (cta) {
      cta.href = shopUrl(machine);
      cta.textContent = machine.threadSize ? 'Shop ' + machine.threadSize + ' Lug Nuts' : 'Get Fitment Help';
    }

    message.hidden = false;
  }

  function refreshAll() {
    refreshBar();
    refreshProductMessage();
    refreshCollectionMessage();
  }

  function scrollToFinder() {
    const target = document.getElementById('fitment-finder-section');
    if (!target) return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#fitment-finder-section');
    } else {
      window.location.hash = 'fitment-finder-section';
    }

    return true;
  }

  function isFinderLink(link) {
    if (!link) return false;

    try {
      const url = new URL(link.getAttribute('href'), window.location.href);
      return url.hash === '#fitment-finder-section' && url.pathname === window.location.pathname;
    } catch (error) {
      return false;
    }
  }

  function bindActions() {
    document.addEventListener('click', function (event) {
      const clearButton = event.target.closest('[data-atv-clear-machine]');
      if (clearButton) {
        clearMachine();
        event.preventDefault();
        return;
      }

      const changeLink = event.target.closest('[data-atv-change-machine]');
      if (changeLink) {
        changeLink.href = FINDER_URL;
      }

      const finderLink = event.target.closest('a[href]');
      if (isFinderLink(finderLink) && scrollToFinder()) {
        event.preventDefault();
      }
    });

    window.addEventListener('atvlugnuts:selected-machine-change', refreshAll);
    window.ATVLUGNUTS_GARAGE = {
      key: STORAGE_KEY,
      read: readMachine,
      save: writeMachine,
      clear: clearMachine,
      refresh: refreshAll
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindActions();
      refreshAll();
    });
  } else {
    bindActions();
    refreshAll();
  }
})();
